import { da } from "date-fns/locale";
import { useState } from "react";
import Swal from "sweetalert2";

const SchedulePopUp = ({ isOpen, onClose, setData, scheduleTime }) => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");

    const [startDateTime, setStartDateTime] = useState("")
    const [endDateTime, setEndDateTime] = useState("")

    const [scheduleType, setScheduleType] = useState("non_recurring")
    const [recurring_type, setRecurringType] = useState("")
    const [days, setDays] = useState("")

    const handleScheduleType = (event) => {
        setScheduleType(event.target.value)
    }

    const handleRecurringMode = (event) => {
        setDays("")
        setRecurringType(event.target.value)
        if (event.target.value === "week_days") {
            setDays("Week_days")
        } else {
            console.log("Choose a day")
        }
    }

    const handleDays = (event) => {
        setDays(event.target.value)
    }

    if (!isOpen) return null;

    const isSameDateTime = (startDate, startTime, endDate, endTime) => {
        if (scheduleType == "non_recurring") {
            if (!startDate || !startTime || !endDate || !endTime) {
                return { valid: false, message: "All date and time fields are required" };
            }

            const start = new Date(`${startDate}T${startTime}`);
            const end = new Date(`${endDate}T${endTime}`);

            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return { valid: false, message: "Invalid date or time format" };
            }

            if (end.getTime() < start.getTime()) {
                return { valid: false, message: "End time should be greater than start time" };
            }

            if (end.getTime() === start.getTime()) {
                return { valid: false, message: "Start and end date-time must be different" };
            }
        }
        return { valid: true, message: "" };

    };


    const handleSaveSchedule = () => {
        if (scheduleType == "non_recurring") {
            if (startDateTime == "" || startTime == "") {
                Swal.fire({
                    title: "!Warning",
                    text: "Please add schedule",
                    confirmButtonColor: "#3085d6",
                })
                return;
            }
        }


        const validation = isSameDateTime(startDateTime, startTime, endDateTime, endTime);

        if (!validation.valid) {
            Swal.fire({
                title: "Warning",
                text: validation.message,
                confirmButtonColor: "#3085d6",
            });
            return;
        }

        console.log(startTime, "------------", endTime)
        if (startTime === "00:00" || startTime === "0:0" || startTime == "") {
            Swal.fire({
                icon: "error",
                title: "Invalid Start Time",
                text: "Start time cannot be 00:00",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (endTime < startTime) {
            Swal.fire({
                icon: "error",
                title: "End time should be greater than start time",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (endTime == startTime) {
            Swal.fire({
                icon: "error",
                title: "Start and end date-time must be different",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
            return;
        }

        if (recurring_type == "day" && days == "") {
            Swal.fire({
                icon: "warning",
                title: "Please Choose a day",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });
            return;
        }

        const weekDaysExists = Array.isArray(scheduleTime) &&
            scheduleTime.some(
                item =>
                    item.schedule_mode?.toLowerCase() === "week_days"
            );

        if (weekDaysExists) {
            // if (recurring_type == "week_days") {
            Swal.fire({
                icon: "warning",
                title: "Week Days Schedule Already Exists",
                text: "A week days schedule is already added. Please remove the existing schedule before adding a new one.",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });

            return;
            // }
        }
        if (recurring_type == "week_days") {
            setDays("Week_days")
        }
        const DaysExists = Array.isArray(scheduleTime) &&
            scheduleTime.some(
                item =>
                    item.schedule_mode?.toLowerCase() === "day"
            );

        if (DaysExists) {
            if (recurring_type == "week_days") {
                Swal.fire({
                    icon: "warning",
                    title: "Day Schedule Exists",
                    text: "If you want to add week_days schedule. Please remove the existing schedule before adding a new one.",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                });

                return;
            }
        }
        const scheduleObj = {
            id: null,
            schedule_type: scheduleType,
            start_date: startDateTime,
            end_date: endDateTime,
            start_time: startTime,
            end_time: endTime,
            schedule_mode: recurring_type,
            recurring_days: days
        };

        setData(old => ({
            ...old,
            schedule_time: [
                ...(old.schedule_time || []),
                scheduleObj
            ]
        }));

        setStartTime("");
        setEndTime("");
        setStartDateTime("");
        setEndDateTime("");
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-xl shadow-xl w-[52rem] p-6">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">Add Schedule Time</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>

                <div className="w-[15rem] flex space-x-5">
                    <div>
                        <h1 className="text-md text-slate-400 pt-8">Schedule Type</h1>
                        <select
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
                            value={scheduleType}
                            onChange={handleScheduleType}
                        >
                            <option value={"non_recurring"}>Non Recurring</option>
                            <option value={"recurring"}>Recurring</option>
                        </select>
                    </div>
                    {scheduleType === "recurring" ? (
                        <div>
                            <h1 className="text-md text-slate-400 pt-8">Recurring Mode</h1>
                            <select
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
                                value={recurring_type}
                                onChange={handleRecurringMode}
                            >
                                <option value="" selected>Select an option</option>
                                <option value={"week_days"}>Week days</option>
                                <option value={"day"}>Day</option>
                            </select>
                        </div>
                    ) : (<></>)}

                    {recurring_type === "day" ? (
                        <div>
                            <h1 className="text-md text-slate-400 pt-8">Recurring Days</h1>
                            <select
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[15rem] p-2.5 "
                                value={days}
                                onChange={handleDays}
                            >
                                <option value={""}>Select days</option>
                                <option value={"mon"}>Mon</option>
                                <option value={"tue"}>Tue</option>
                                <option value={"wed"}>Wed</option>
                                <option value={"thu"}>Thu</option>
                                <option value={"fri"}>Fri</option>
                            </select>
                        </div>
                    ) : (<></>)}
                </div>

                <div className="flex space-x-4">
                    {scheduleType == "non_recurring" ?
                        <div>
                            <h1 className="text-md text-slate-400 mb-1">Start Date</h1>
                            <input
                                type="date"
                                value={startDateTime}
                                onChange={(e) => setStartDateTime(e.target.value)}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5"
                                min={new Date().toISOString().slice(0, 16)}
                            />
                        </div>
                        : <></>}
                    <div>
                        <h1 className="text-md text-slate-400 mb-1">Start Time</h1>
                        <input
                            type="time"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5"
                        />
                    </div>
                </div>

                <div className="flex space-x-4">
                    {scheduleType == "non_recurring" ?
                        <div>
                            <h1 className="text-md text-slate-400 mb-1">End Date</h1>
                            <input
                                type="date"
                                value={endDateTime}
                                onChange={(e) => setEndDateTime(e.target.value)}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5"
                                min={new Date().toISOString().slice(0, 16)}
                            />
                        </div>
                        : <></>}
                    <div>
                        <h1 className="text-md text-slate-400 mb-1">End Time</h1>
                        <input
                            type="time"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-[20rem] h-10 p-2.5"
                            min={new Date().toISOString().slice(0, 16)}
                        />
                    </div>

                    <div className="flex items-end">
                        <button
                            onClick={handleSaveSchedule}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold h-10 px-6 rounded-lg"
                        >
                            Add
                        </button>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default SchedulePopUp;